import './timeline.scss';
import Timeline from './timeline';
import { on_ready } from 'js/utils';

on_ready(()=>{
    new Timeline({
        container: '.timeline',
        rows: '.timeline_row',
        trigger_offset: 150, // bottom of screen
        line_guide: false,
    })
})